import createGlobalEventReducer from 'web-app/react/global-event/helpers/create-reducer';

import * as Actions from './actions';

export default createGlobalEventReducer(Actions);
